import { slice } from './slice';

export const { actions, reducer } = slice;
export { selectors } from './adapter';
export * as thunks from './thunks';
